/**
 * uiBootstrapDatepickerDecorator
 *
 * Adds to ui-bootstrap datepicker parser.
 * If the input can be parsed with Sugarjs Date.create(), it is passed to the original parse function as a proper
 * ISO string. This lets user's enter things like, 'tomorrow' or 'yesterday'.
 */
(function(){
    angular
        .module('ui.bootstrap.dateparser')
        .config(configure);
    configure.$inject = ['$provide'];
    function configure($provide){
        $provide.decorator('dateParser', dateParserDecorator);

        dateParserDecorator.$inject = ['$delegate'];

        function dateParserDecorator($delegate){
            var ISO8601Format = 'yyyy-MM-ddTHH:mm:ss.sssZ';
            var delegateParse = $delegate.parse;
            $delegate.parse = parse;
            return $delegate;

            function parse(input, format, baseDate) {
                var date = Date.create(input);
                if(input && date.isValid()){
                    input = date.toISOString();
                    format = ISO8601Format;
                }
                return delegateParse.call(this, input, format, baseDate);
            }
        }
    }
})();